import { React, useContext, createContext, useState } from "react";

const AppContext = createContext();

const AppProvider = ({ children }) => {
  const [pgn, setPgn] = useState("");
  const [fen, setFen] = useState(
    "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"
  );
  const [isGameOver, setIsGameOver] = useState(false);
  const [letRedo, setLetRedo] = useState(true);
  // pieces color: 1 - white, 0 - black
  const [piecesColor, setPiecesColor] = useState(
    localStorage.getItem("piecesColor") === null
      ? 1
      : JSON.parse(localStorage.getItem("piecesColor"))
  );
  const [boardOrientation, setBoardOrientation] = useState(
    localStorage.getItem("boardOrientation") === null
      ? "white"
      : localStorage.getItem("boardOrientation")
  );
  const [engineStrength, setEngineStrength] = useState(
    localStorage.getItem("engineStrength") === null
      ? 1000
      : localStorage.getItem("engineStrength")
  );
  const [resetBoard, setResetBoard] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [showNotation, setShowNotation] = useState(
    localStorage.getItem("showNotation") === null
      ? true
      : JSON.parse(localStorage.getItem("showNotation"))
  );
  const [chessboardColor, setChessboardColor] = useState(
    localStorage.getItem("chessboardColor") === null
      ? "color-brown"
      : JSON.parse(localStorage.getItem("chessboardColor"))
  );

  const [showEvaluationBar, setShowEvaluationBar] = useState(
    localStorage.getItem("showEvaluationBar") === null
      ? true
      : JSON.parse(localStorage.getItem("showEvaluationBar"))
  );
  const [stockfishDepth, setStockfishDepth] = useState(12);
  const [stockfishEvaluation, setStockfishEvaluation] = useState("0.0");
  const [showStockfishEvaluation, setShowStockfishEvaluation] = useState(true);
  const [mateSoon, setMateSoon] = useState(null);
  const [showMaterialInfo, setShowMaterialInfo] = useState(true);
  const [startPosition, setStartPosition] = useState(
    "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"
  );
  const [bestMove, setBestMove] = useState({});
  const [showBestMove, setShowBestMove] = useState(false);
  const [bestMoveCoords, setBestMoveCoords] = useState({});
  const [size, setSize] = useState(
    window.innerWidth < 650 ? window.innerWidth - 100 : 550
  );
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [stockfishVersion, setStockfishVersion] = useState("11");
  const [gameAgainstComputer, setGameAgainstComputer] = useState(true);
  const [lozzaDepth, setLozzaDepth] = useState(12);
  const [showLozzaEvaluation, setShowLozzaEvaluation] = useState(true);
  const [showVariants, setShowVariants] = useState(true);
  const [newChess960Game, setNewChess960Game] = useState(true);

  return (
    <AppContext.Provider
      value={{
        pgn,
        setPgn,
        fen,
        setFen,
        isGameOver,
        setIsGameOver,
        letRedo,
        setLetRedo,
        piecesColor,
        setPiecesColor,
        boardOrientation,
        setBoardOrientation,
        resetBoard,
        setResetBoard,
        engineStrength,
        setEngineStrength,
        showSidebar,
        setShowSidebar,
        showNotation,
        setShowNotation,
        chessboardColor,
        setChessboardColor,
        showEvaluationBar,
        setShowEvaluationBar,
        stockfishDepth,
        setStockfishDepth,
        stockfishEvaluation,
        setStockfishEvaluation,
        showStockfishEvaluation,
        setShowStockfishEvaluation,
        mateSoon,
        setMateSoon,
        showMaterialInfo,
        setShowMaterialInfo,
        startPosition,
        setStartPosition,
        bestMove,
        setBestMove,
        showBestMove,
        setShowBestMove,
        bestMoveCoords,
        setBestMoveCoords,
        size,
        setSize,
        showColorPicker,
        setShowColorPicker,
        stockfishVersion,
        setStockfishVersion,
        gameAgainstComputer,
        setGameAgainstComputer,
        lozzaDepth,
        setLozzaDepth,
        showLozzaEvaluation,
        setShowLozzaEvaluation,
        showVariants,
        setShowVariants,
        newChess960Game,
        setNewChess960Game,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useGlobalContext = () => {
  return useContext(AppContext);
};

export { AppContext, AppProvider };
